import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { blockUser, unBlockUser } from '../../redux/actions/auth';
import { Loading } from '..';
import useSettings from '../../hooks/useSettings';

import GeneralNotifModal from '../GeneralModal/generalNotifModal';
import radioChecked from '../../assets/radio-checked.svg';
import { authPopup } from '../../redux/actions/auth';

import styles from './style.module.css';

const commentBlockDescription =
  'Block means he/she will no longer be able to send message, follow and watch your content.';
const blockDescription = `Block means you or he/she will no longer be able to send message, follow and watch your/his/her content`;

function BlockUnblockModal({
  profile,
  isTriggered,
  onClose,
  blockType,
  blockFrom = '',
  checkType = '',
  isSameCommentUploader = false,
}) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [showBlockModal, setBlockModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const { token } = useSelector((state) => state.auth);

  const [blockStringTitle, setBlockTitle] = useState('');
  const [blockStringDescription, setBlockDescription] = useState('');

  const [accessModal, setAccessModal] = useState(false);

  const [isBlocked, setBlocked] = useState(false);

  const settings = useSettings();

  const isProfileType = checkType === 'profile';

  const {
    blockerAccessContentMessage,
    blockerAccessContentTitle,
    blockeeFollowProfileMessage,
    blockeeFollowProfileTitle,
    blockerFollowProfileMessage,
    blockerFollowProfileTitle,
    blockerUnblockDialogMessage,
    blockerUnblockDialogTitle,
  } = settings;

  const replaceBlockeeName = (str, name) => {
    if (str) {
      str = str.replace('[blockee_name]', name);
      if (str.includes('\\n\\n')) {
        return (
          <span>
            {str.split('\\n\\n')[0]} <br />
            <br />
            {str.split('\\n\\n')[1]}
          </span>
        );
      }

      return str;
    }
  };

  const blockButton = isBlocked ? 'Unblock' : 'Block';
  useEffect(() => {
    if (blockType === 'access') {
      return;
    }
    setBlocked(isBlocked ? true : false);

    const isUnblock = blockType === 'unblock';
    let title =
      isUnblock && blockFrom === 'comment' && !isSameCommentUploader
        ? blockerUnblockDialogTitle
        : blockerAccessContentTitle;
    let desc =
      isUnblock && blockFrom === 'comment' && !isSameCommentUploader
        ? blockerUnblockDialogMessage
        : blockerAccessContentMessage;

    if (isProfileType) {
      title = blockerFollowProfileTitle;
      desc = blockerFollowProfileMessage;
    }

    if (isBlocked) {
      setBlockTitle(`${replaceBlockeeName(title || '', profile?.name)}`);
      setBlockDescription(replaceBlockeeName(desc || '', profile?.name));
      // setBlockDescription(
      //   `${profile?.name} will now be able to see your liveshow, clips, follow and send chat/message on your content.`
      // );
    } else {
      setBlockTitle(`Block ${profile?.name}?`);
      blockFrom === 'comment' || blockFrom === 'profile'
        ? setBlockDescription(commentBlockDescription)
        : setBlockDescription(blockDescription);
    }
  }, [
    isBlocked,
    blockerAccessContentMessage,
    blockerAccessContentTitle,
    blockFrom,
    blockType,
    profile,
    blockerFollowProfileMessage,
    blockerFollowProfileTitle,
    isProfileType,
    blockerUnblockDialogMessage,
    blockerUnblockDialogTitle,
    isSameCommentUploader,
  ]);

  useEffect(() => {
    if (blockType === 'block') {
      setBlockModal(isTriggered);
      setBlocked(false);
      setAccessModal(false);
    }
    if (blockType === 'unblock') {
      setBlockModal(isTriggered);
      setBlocked(true);
      setAccessModal(false);
    }

    if (blockType === 'access') {
      setBlockModal(false);
      setAccessModal(true);
    }
  }, [isTriggered, blockType]);

  const closeAllModals = () => {
    setBlockModal(false);
    setShowSuccessModal(false);
  };

  const blockProfile = async () => {
    if (blockFrom === 'comment' && !token) {
      dispatch(authPopup.show());
      return;
    }
    if (profile?.accountId) {
      setLoading(true);
      const res = await dispatch(blockUser(profile?.accountId));
      if (res) {
        setBlocked(true);
        setBlockModal(false);
        setShowSuccessModal(true);
      }
    }
    setLoading(false);
  };

  const unBlockUserProfile = async () => {
    if (profile?.accountId) {
      setLoading(true);
      const res = await dispatch(unBlockUser(profile?.accountId));
      if (res) {
        setBlocked(true);
        closeAllModals();
        onClose('unblocked');
        // dispatch(getPublicProfileInfo(profileId))
      }
    }
    setLoading(false);
  };

  if (!isTriggered) {
    return null;
  }
  return (
    <GeneralNotifModal open={isTriggered}>
      {showBlockModal && blockStringDescription && blockStringTitle && (
        <div className={styles.reportContainer}>
          <div
            className={styles.blockTitle}
            style={{
              color: `${blockType === 'access' ? '#F20303' : '#F49832'}`,
            }}
          >
            {blockStringTitle}
          </div>
          <div className={styles.blockSubTitle}>{blockStringDescription}</div>
          {loading ? (
            <Loading />
          ) : (
            <div
              className={styles.reportButton}
              onClick={() => {
                isBlocked ? unBlockUserProfile() : blockProfile();
                // setBlocked(true)
              }}
            >
              {blockButton}
            </div>
          )}
          <div
            className={styles.cancelButton}
            onClick={() => {
              closeAllModals();
              onClose('cancel');
            }}
          >
            Cancel
          </div>
        </div>
      )}
      {showSuccessModal && (
        <div className={styles.reportContainer}>
          <img src={radioChecked} alt='radio' height='40' width='40' />
          <div className={styles.reportThanksTitle}>
            {profile?.name} has been blocked
          </div>
          <div className={styles.reportThanksSubTitle}>
            You can unblock them anytime from your profile.
          </div>
          <div
            className={styles.closeButton}
            onClick={() => {
              closeAllModals();
              onClose('blocked');
            }}
          >
            Close
          </div>
        </div>
      )}
      {accessModal && (
        <div className={styles.reportContainer}>
          <div className={styles.blockTitle}>
            {isProfileType
              ? blockeeFollowProfileTitle
              : settings.blockeeAccessContentTitle}
          </div>
          <div className={styles.reportThanksSubTitle}>
            {isProfileType
              ? blockeeFollowProfileMessage
              : settings.blockeeAccessContentMessage}
          </div>
          <div
            className={styles.closeButton}
            onClick={() => {
              closeAllModals();
              onClose('cancel');
            }}
          >
            Close
          </div>
        </div>
      )}
    </GeneralNotifModal>
  );
}

export default React.memo(BlockUnblockModal);
